import { avatarColorForId, avatarInitials } from '../utils/supportAvatar';

type Props = {
  role: 'user' | 'support';
  userId?: number | null;
  firstName?: string | null;
  username?: string | null;
  /** Admin alias / display name — preferred for support avatars */
  displayName?: string | null;
  title?: string;
  onClick?: () => void;
  size?: 'sm' | 'md';
};

export function SupportAvatar({
  role,
  userId,
  firstName,
  username,
  displayName,
  title,
  onClick,
  size = 'md',
}: Props) {
  const isSupport = role === 'support';
  const colorId = userId ?? 0;
  const color = isSupport
    ? displayName || userId
      ? avatarColorForId(colorId || hashStr(displayName || 'S'))
      : '#64748b'
    : avatarColorForId(colorId);
  const label = avatarInitials({
    support: isSupport,
    firstName,
    username,
    userId,
    displayName,
  });
  const clickable = Boolean(onClick) && !isSupport;
  const className = `support-avatar support-avatar-${size}${isSupport ? ' is-support' : ' is-user'}${
    clickable ? ' is-clickable' : ''
  }`;

  const inner = (
    <span className="support-avatar-label" aria-hidden>
      {label}
    </span>
  );

  if (clickable) {
    return (
      <button
        type="button"
        className={className}
        style={{ background: color }}
        title={title || 'Карточка клиента'}
        aria-label={title || 'Открыть карточку клиента'}
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
      >
        {inner}
      </button>
    );
  }

  return (
    <span
      className={className}
      style={{ background: color }}
      title={title || (isSupport ? displayName || 'Поддержка' : undefined)}
      aria-hidden={isSupport && !displayName ? true : undefined}
    >
      {inner}
    </span>
  );
}

function hashStr(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}
